<template lang="pug">
    fragment
        // Arrow
        td
            expand-component(:class="{'expanded' : expanded}")

        // Business Name
        td {{ item.fullName }}
</template>

<script>
    import VueTypes from 'vue-types';
    import ExpandIcon from '~components/ExpandIcon';

    export default {
        comments: {
            ExpandComponent: ExpandIcon
        },
        props: {
            item: VueTypes.object.def({}),
            expanded: VueTypes.bool.def(false)
        }
    };
</script>
